export default __webpack_public_path__ + "static/media/plusicon.ab554e54.svg";